import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { SearchIcon, BookOpenIcon } from 'lucide-react';
export const DocumentationPage = () => {
  const [scrolled, setScrolled] = useState(false);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-5687">
      <Navbar scrolled={scrolled} data-id="element-5688" />
      <main className="pt-24 pb-20" data-id="element-5689">
        <div className="container mx-auto px-4 md:px-6" data-id="element-5690">
          <div className="max-w-4xl mx-auto text-center" data-id="element-5691">
            <BookOpenIcon className="h-16 w-16 mx-auto text-[#2DB489] dark:text-[#4ED1A0] mb-6" data-id="element-5692" />
            <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-5693">
              Documentation
            </h1>
            <p className="text-xl text-gray-600 dark:text-[#B0C1BD] mb-8 max-w-3xl mx-auto" data-id="element-5694">
              Our comprehensive documentation is coming soon to help you get the
              most out of our platform.
            </p>
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 shadow-sm mb-12" data-id="element-5695">
              <div className="flex items-center justify-center mb-6" data-id="element-5696">
                <div className="relative w-full max-w-md" data-id="element-5697">
                  <input type="text" placeholder="Search documentation..." className="w-full px-4 py-3 pr-10 rounded-lg border border-gray-200 dark:border-[#1A3330] bg-white dark:bg-[#162825] text-gray-800 dark:text-[#F8FAF9] focus:outline-none focus:ring-2 focus:ring-[#2DB489] dark:focus:ring-[#4ED1A0]" data-id="element-5698" />
                  <SearchIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400 dark:text-[#7A8F8A]" data-id="element-5699" />
                </div>
              </div>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6" data-id="element-5700">
                We're currently working on comprehensive documentation for our
                platform. Check back soon for:
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5701">
                <div className="bg-gray-50 dark:bg-[#1A3330] p-4 rounded-lg" data-id="element-5702">
                  <h3 className="font-semibold text-gray-800 dark:text-[#F8FAF9] mb-2" data-id="element-5703">
                    Getting Started Guides
                  </h3>
                  <p className="text-gray-600 dark:text-[#B0C1BD] text-sm" data-id="element-5704">
                    Step-by-step instructions for new users
                  </p>
                </div>
                <div className="bg-gray-50 dark:bg-[#1A3330] p-4 rounded-lg" data-id="element-5705">
                  <h3 className="font-semibold text-gray-800 dark:text-[#F8FAF9] mb-2" data-id="element-5706">
                    Seller Resources
                  </h3>
                  <p className="text-gray-600 dark:text-[#B0C1BD] text-sm" data-id="element-5707">
                    How to create and sell digital products
                  </p>
                </div>
                <div className="bg-gray-50 dark:bg-[#1A3330] p-4 rounded-lg" data-id="element-5708">
                  <h3 className="font-semibold text-gray-800 dark:text-[#F8FAF9] mb-2" data-id="element-5709">
                    Buyer Guides
                  </h3>
                  <p className="text-gray-600 dark:text-[#B0C1BD] text-sm" data-id="element-5710">
                    Finding and purchasing the right products
                  </p>
                </div>
                <div className="bg-gray-50 dark:bg-[#1A3330] p-4 rounded-lg" data-id="element-5711">
                  <h3 className="font-semibold text-gray-800 dark:text-[#F8FAF9] mb-2" data-id="element-5712">
                    API Documentation
                  </h3>
                  <p className="text-gray-600 dark:text-[#B0C1BD] text-sm" data-id="element-5713">
                    Integrate with our platform programmatically
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 text-white" data-id="element-5714">
              <h2 className="text-2xl font-bold mb-3" data-id="element-5715">Need Help Now?</h2>
              <p className="mb-6 opacity-90" data-id="element-5716">
                Can't wait for our documentation? Our support team is ready to
                assist you.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-5717">
                <button className="bg-white text-[#0A3C52] px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors" data-id="element-5718">
                  Contact Support
                </button>
                <button className="bg-transparent border border-white text-white px-6 py-3 rounded-lg font-medium hover:bg-white/10 transition-colors" data-id="element-5719">
                  Visit Community Forum
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-5720" />
    </div>;
};